import { render, staticRenderFns } from "./marketing-record.vue?vue&type=template&id=ef51ce32&scoped=true"
import script from "./marketing-record.vue?vue&type=script&lang=js"
export * from "./marketing-record.vue?vue&type=script&lang=js"
import style0 from "./marketing-record.vue?vue&type=style&index=0&id=ef51ce32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef51ce32",
  null
  
)

export default component.exports